module.exports = __webpack_public_path__ + "img/nh3.0baa0788.svg";